(ns app.front.view.admin.domain-groups.subs
  (:require [app.front.view.admin.subs :as admin-subs]
            [app.i18n.model :as i18n-model]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::municipalities
  :<- [::admin-subs/dialog-data :new-municipality :municipalities]
  (fn [municipalities _]
    (or municipalities [])))


(rf/reg-sub ::municipalities-sorted
  :<- [::municipalities]
  :<- [:language]
  (fn [[municipalities lang] _]
    (let [get-str #(i18n-model/get-text-from-entities-or-map % lang)]
      ;; sort using UI language
      (->> municipalities
           (sort-by (comp get-str :name))))))


(rf/reg-sub ::coordinates
  :-> ::coordinates)


(rf/reg-sub ::location-of
  :<- [::coordinates]
  (fn [coords [_ municipality-number]]
    (get coords municipality-number)))


(rf/reg-sub ::default-location
  :<- [::coordinates]
  :<- [::admin-subs/dialog-data :new-municipality :group-number]
  (fn [[coords group-number] _]
    (or (get coords group-number)
        [-8836401 5410894])))


(rf/reg-event-fx ::fetch-municipalities-public.success
  (fn [{:keys [db]} [_ status response]]
    (when (= status 200)
      {:db (-> db
               (assoc ::coordinates (->> response
                                         vals
                                         (apply concat)
                                         (map (juxt :municipality :map-center))
                                         (into {}))))})))


(rf/reg-event-fx
  ::fetch-municipalities-public
  (fn [_ _]
    {:comm/command {:command    :municipality/municipalities
                    :method     :get
                    :on-success [::fetch-municipalities-public.success]}}))






(rf/reg-event-fx ::municipality-geocoding.success
  (fn [_ [_ callback _ {:keys [coordinates municipality-number]}]]
    (callback coordinates municipality-number)))


(rf/reg-event-fx ::geocoding-request.failure
  (fn [_]))


(rf/reg-event-fx ::geocode-municipality
  (fn [{:keys [db]} [_ municipality-name callback]]
    (let [{:keys [subdivision country-code]} (:new-municipality db)]
      (when (and (string? municipality-name)
                 (>= (count municipality-name) 5)
                 subdivision
                 country-code)
        {:dispatch-debounce {:id      ::request-geocoding
                             :timeout 300
                             :action  :dispatch
                             :event   [::do-geocoding-request
                                       {:search-text municipality-name
                                        :subdivision subdivision
                                        :country     country-code}
                                       [::municipality-geocoding.success callback]]}}))))


(rf/reg-event-fx ::do-geocoding-request
  (fn [_ [_ data on-success]]
    {:comm/command {:command         :admin/find-municipality-setup-data
                    :method          :get
                    :data            data
                    :on-success      on-success
                    :on-not-found    [::geocoding-request.failure]
                    :on-server-error [::geocoding-request.failure]}}))


(rf/reg-event-db ::remove-municipality
  (fn [db [_ {:keys [number]}]]
    (update-in db [:new-municipality :municipalities] (partial remove #(or (= number (:number %))
                                                                           (empty? %))))))
